/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const dialogModalStyle = {
  closeButton: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
  },
  divider: {
    margin: "1.5rem 0",
  },
};

export default dialogModalStyle;
